import { ITeamFilters } from '@/types';
import { TeamItem } from '@/models/team';
import equal from 'fast-deep-equal';

export const useTeamStore = defineStore('team', () => {
    const items = shallowRef<TeamItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const filters = reactive<ITeamFilters>({
        name: '',
        countryId: null,
        typeId: null,
        women: null,
        youth: null,
        isFavoriteOnly: false,
    });
    const isExtraFiltersDisplayed = ref<boolean>(false);
    const favoriteTeam = ref<Record<number, number>>({});
    const favoriteTeamProcessing = ref<Record<number, boolean>>({});

    function setFavoriteTeams(teams: Record<number, number>) {
        if (!equal(favoriteTeam.value, teams)) {
            console.log('Set favorite teams');
            favoriteTeam.value = teams;
        }
    }

    return {
        items,
        total,
        loading,
        filters,
        isExtraFiltersDisplayed,
        favoriteTeam,
        favoriteTeamProcessing,
        setFavoriteTeams,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTeamStore, import.meta.hot));
}
